import { Zap, Tag, HeartHandshake, Target } from "lucide-react";
import { Reveal } from "./Reveal";

const reasons = [
  {
    icon: Zap,
    title: "Rapidez de entrega",
    text: "Tu web lista en pocos días, sin esperas eternas ni procesos interminables.",
  },
  {
    icon: Tag,
    title: "Precio claro sin sorpresas",
    text: "Sabes exactamente lo que pagas desde el primer momento. Sin costes ocultos.",
  },
  {
    icon: HeartHandshake,
    title: "Trato cercano y personalizado",
    text: "Hablamos tu idioma. Te acompañamos y adaptamos la web a tu negocio real.",
  },
  {
    icon: Target,
    title: "Orientado a captar clientes",
    text: "Cada web se diseña con un objetivo: que te encuentren, te elijan y te contacten.",
  },
];

export const WhyUs = () => (
  <section id="por-que-elegirnos" data-testid="whyus-section" className="relative mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-32">
    <Reveal className="max-w-2xl">
      <span className="text-sm font-medium uppercase tracking-[0.25em] text-[#00E5FF]">03 — Por qué elegirnos</span>
      <h2 className="mt-5 font-head text-4xl font-light leading-tight tracking-tight text-white sm:text-5xl">
        Un manifiesto en <span className="font-black">cuatro puntos</span>
      </h2>
    </Reveal>

    <div className="mt-16 divide-y divide-white/10 border-y border-white/10">
      {reasons.map((r, i) => {
        const Icon = r.icon;
        return (
          <Reveal key={r.title} delay={i * 0.08}>
            <div className="group grid grid-cols-1 items-center gap-6 py-10 md:grid-cols-12 md:gap-8">
              <div className="font-head text-5xl font-extralight text-white/25 transition-colors group-hover:text-[#00E5FF] md:col-span-2">
                0{i + 1}
              </div>
              <div className="flex items-center gap-4 md:col-span-4">
                <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-[#00E5FF]">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="font-head text-2xl font-medium text-white">{r.title}</h3>
              </div>
              <p className="text-lg leading-relaxed text-zinc-400 md:col-span-6">{r.text}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
